import { useEffect, useRef, useState, useContext } from 'react';

import styles from './TopicDetailsComponent.module.css'

import { GlobalContext } from "../../contexts/globalContext";
import { AddConferenceContext } from "../../contexts/addConferenceContext";

import PdfIcon from '../../graphics/conference/file-pdf.png'
import DocIcon from '../../graphics/conference/file-docs.png'
import SheetIcon from '../../graphics/conference/file-sheet.png'
import VideoIcon from '../../graphics/conference/file-video.png';
import SiteIcon from '../../graphics/conference/file-site.png';

import loadingAnimation from '../../graphics/conference/loadin-file-anim.json'

import Lottie from 'react-lottie-player';

const TopicDetailsComponent = ({ topic }) => {

    const { setOpenedFiles, appHeight, openedFiles, sharedFiles, loadingFiles, setLoadingFiles, currentParticipant, appWidth } = useContext(GlobalContext);
    const { setOpenFiles, openFilesRef, setConferenceAddFiles } = useContext(AddConferenceContext);

    const subtopicListRef = useRef()

    const [selectedSubtopic, setSelectedSubtopic] = useState();

    let oxDivider = window.innerWidth / appWidth;

    useEffect(() => {
        subtopicListRef.current.scrollLeft = 0;
    }, [selectedSubtopic])

    const GetIcon = (docsFile) => {
        switch (docsFile?.type) {
            case "doc":
                return DocIcon;
            case "sheet":
                return SheetIcon;
            case "image":
                return process.env.REACT_APP_CMS_URL + docsFile.path;
            case "video":
                return VideoIcon;
            case "pdf":
                return PdfIcon;
            case "site":
                return SiteIcon;
            default:
                return <i className="bi bi-file-earmark-text" style={{ fontSize: "70px" }}></i>;
        }
    }

    const OpenFile = (file) => {
        var in_opened_files = openedFiles.find(xf => xf.uid === file._id);
        var in_shared_files = sharedFiles.find(xf => xf.uid === file._id);
        if (!in_opened_files && !in_shared_files) {
            setOpenedFiles(files => [...files, {
                isNew: true,
                uid: file._id,
                isModerator: topic.moderator ? topic.moderator._id === currentParticipant?._id : false,
                x: 1500,
                y: appHeight / 2,
                type: file.docsFile.type,
                path: file.docsFile.path,
                name: file.docsFile.name,
                scale: 1,
                rotation: 0
            }])
            if (file.docsFile.type !== "image") {
                setLoadingFiles(files => [...files, file._id])
            }
        }
    }

    const isDown = useRef(false);
    const startX = useRef(0);
    const startScrollLeft = useRef(0);
    const didDrag = useRef(false);
    const down = useRef({ x: 0, y: 0 });


    const DRAG_THRESHOLD = 6;

    const onMouseDown = (e) => {
        isDown.current = true;
        didDrag.current = false;
        down.current = { x: e.pageX, y: e.pageY };

        startX.current = e.pageX;
        startScrollLeft.current = subtopicListRef.current.scrollLeft;
    };

    const onMouseMove = (e) => {
        if (!isDown.current) return;

        const dxPx = e.pageX - down.current.x;
        const dyPx = e.pageY - down.current.y;

        if (!didDrag.current && (Math.abs(dxPx) > DRAG_THRESHOLD || Math.abs(dyPx) > DRAG_THRESHOLD)) {
            didDrag.current = true;
        }

        if (didDrag.current) e.preventDefault();

        const dx = (e.pageX - startX.current) / oxDivider;
        subtopicListRef.current.scrollLeft = startScrollLeft.current - dx * 1.2;
    };

    const stopDrag = () => {
        if (!isDown.current) return;
        isDown.current = false;

        setTimeout(() => {
            didDrag.current = false;
        }, 0);
    };

    const onClickCapture = (e) => {
        if (!didDrag.current) return;
        e.preventDefault();
        e.stopPropagation();
    };

    useEffect(() => {
        window.addEventListener("mouseup", stopDrag);
        return () => window.removeEventListener("mouseup", stopDrag);
    }, []);

    return (
        <div style={{ position: "relative", padding: "0px", width: "900px", display: "flex", flexDirection: "column", overflow: "hidden", border: "0px", borderRadius: "0px 0px 10px 10px" }}>
            <div onClick={() => setSelectedSubtopic(null)} style={{
                height: `${selectedSubtopic ? 100 : 0}px`, transition: "height 0.5s", backgroundColor: "#1C1539", cursor: "pointer",
                color: "white", font: "normal normal 600 34px/36px 'Bio Sans'"
            }}>
                <i className="fa-thin fa-chevron-left" style={{ opacity: `${selectedSubtopic ? 1 : 0}`, font: "normal normal 300 28px/35px", margin: "29px 20px 0px 40px" }}></i>
                {selectedSubtopic?.name}
            </div>
            <div ref={subtopicListRef} className={styles.subtopicsListScrollBar} style={{
                backgroundColor: "#1C1539", width: "900px", display: "flex", flexDirection: "row",
                justifyContent: "start", padding: "0px"
            }}
                onMouseDown={onMouseDown}
                onMouseMove={onMouseMove}
                onMouseLeave={stopDrag}
                onClickCapture={onClickCapture}
            >
                {!selectedSubtopic && topic.subtopics.map((subtopic) => (
                    <div key={subtopic._id} onClick={() => setSelectedSubtopic(subtopic.files.length > 0 ? subtopic : null)} className={styles.subtopicElement}
                        style={{ backgroundColor: "#292148", width: "470px", height: "250px", fontSize: "40px", margin: "20px 10px" }}>
                        <div className={styles.title}>{subtopic.name}</div>
                        <div className={styles.subtitle}>{subtopic.files.length > 0 ? subtopic.files.length : "No"} files</div>
                    </div>
                ))}

                {!selectedSubtopic && topic.files.map((file) => (
                    <div onClick={() => OpenFile(file)} key={file._id} className={styles.fileElement}
                        style={{ height: "250px", fontSize: "40px", margin: "20px 20px", position: "relative" }}>
                        {file.docsFile.type !== "image" && loadingFiles.includes(file._id) && <Lottie
                            loop
                            play
                            animationData={loadingAnimation}
                            style={{ position: 'absolute', top: -10, left: 0, width: '100%', height: '100%', background: 'transparent', }}
                        />}
                        <img src={GetIcon(file.docsFile)} draggable={false} height={220} style={{ position: 'relative', top: 0, left: 0, width: 'auto', height: '220px' }} />
                        <div className={styles.file_title} style={{ font: "normal normal 600 18px/20px Bio Sans" }}>{file.docsFile.name}</div>
                    </div>
                ))}

                {selectedSubtopic && selectedSubtopic.files.map((file) => (
                    <div onClick={() => OpenFile(file)} key={file._id} className={styles.fileElement} style={{ height: "250px", fontSize: "40px", margin: "20px 20px" }}>
                        <img src={GetIcon(file.docsFile)} height={220} />
                        <div className={styles.file_title} style={{ font: "normal normal 600 18px/20px Bio Sans" }}>{file.docsFile?.name}</div>

                        <div style={{ position: "absolute", right: "10px", top: "2px", cursor: "pointer" }}
                            onClick={(e) => { e.stopPropagation(); setOpenFiles(topic); setConferenceAddFiles(true); openFilesRef.current = topic; }}>
                            <i className="fa-thin fa-edit" style={{ font: "normal normal 300 28px/35px", margin: "10px 20px 40px 0px" }}></i>files
                        </div>
                    </div>
                ))
                }

            </div>
            <div style={{ position: "absolute", width: "40px", height: "100%", background: "linear-gradient(90deg, #1C1539FF 0%, #1C153900 100%)", left: "0px", top: "0px", margin: "0" }}></div>
            <div style={{ position: "absolute", width: "40px", height: "100%", background: "linear-gradient(90deg, #1C153900 0%, #1C1539FF 100%)", right: "0px", top: "0px", margin: "0" }}></div>
        </div>
    );
}

export default TopicDetailsComponent;